(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["droid-dark-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.heroReady === 'true') return;
      root.dataset.heroReady = 'true';
      const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      const current = root.querySelector('[data-hero-current]');
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === index)));
        if (current) current.textContent = String(index + 1).padStart(2, '0');
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => show(index + 1), Number(root.dataset.interval) || 6500);
        }
      };
      root.querySelector('[data-hero-previous]')?.addEventListener('click', () => { show(index - 1); start(); });
      root.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(index + 1); start(); });
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => { show(dotIndex); start(); }));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    };
    document.querySelectorAll('[data-droid-hero-slideshow]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-droid-hero-slideshow]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droid-fashion-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.lookbookReady === 'true') return;
      root.dataset.lookbookReady = 'true';
      const track = root.querySelector('[data-droid-lookbook-track]');
      const cards = Array.from(root.querySelectorAll('[data-droid-look]'));
      const current = root.querySelector('[data-droid-lookbook-current]');
      const dialog = root.querySelector('[data-droid-lookbook-dialog]');
      const autoplay = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Math.max(3000, Number(root.dataset.interval || 5) * 1000);
      let timer = null;
      const setCurrent = () => {
        if (!cards.length) return;
        const index = cards.reduce((best, card, cardIndex) => Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - track.scrollLeft) ? cardIndex : best, 0);
        if (current) current.textContent = String(index + 1).padStart(2, '0');
      };
      const pause = () => { if (timer) window.clearInterval(timer); timer = null; };
      const advance = () => {
        if (!cards.length || dialog?.open) return;
        const index = cards.reduce((best, card, cardIndex) => Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - track.scrollLeft) ? cardIndex : best, 0);
        const next = cards[(index + 1) % cards.length];
        track.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
      };
      const start = () => { pause(); if (autoplay && !document.hidden) timer = window.setInterval(advance, interval); };
      root.querySelector('[data-droid-lookbook-previous]')?.addEventListener('click', () => { pause(); track.scrollBy({left: -track.clientWidth * .72, behavior: 'smooth'}); start(); });
      root.querySelector('[data-droid-lookbook-next]')?.addEventListener('click', () => { pause(); track.scrollBy({left: track.clientWidth * .72, behavior: 'smooth'}); start(); });
      track.addEventListener('scroll', setCurrent, {passive: true});
      cards.forEach((card) => card.addEventListener('click', () => {
        pause();
        dialog.querySelector('[data-droid-lookbook-image]').src = card.dataset.image;
        dialog.querySelector('[data-droid-lookbook-image]').alt = card.dataset.title;
        dialog.querySelector('[data-droid-lookbook-title]').textContent = card.dataset.title;
        dialog.querySelector('[data-droid-lookbook-method]').textContent = card.dataset.method;
        dialog.querySelector('[data-droid-lookbook-description]').textContent = card.dataset.description;
        dialog.querySelector('[data-droid-lookbook-tip]').textContent = card.dataset.tip;
        dialog.showModal();
      }));
      root.querySelector('[data-droid-lookbook-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', start);
      track.addEventListener('mouseenter', pause);
      track.addEventListener('mouseleave', start);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) start(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); else start(); });
      start();
    };
    document.querySelectorAll('[data-droid-lookbook]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-droid-lookbook]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droid-fashion-slideshow"] && !Shopify.designMode) return;
  try {
    
  const initializeDroidFashionSlideshow = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = [...root.querySelectorAll('[data-dot]')];
    const current = root.querySelector('[data-current]');
    const previous = root.querySelector('[data-previous]');
    const next = root.querySelector('[data-next]');
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const show = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === index)));
      if (current) current.textContent = String(index + 1).padStart(2, '0');
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (root.dataset.autoplay === 'true' && !reduceMotion) {
        timer = window.setInterval(() => show(index + 1), Number(root.dataset.interval) || 6000);
      }
    };
    previous?.addEventListener('click', () => {
      show(index - 1);
      start();
    });
    next?.addEventListener('click', () => {
      show(index + 1);
      start();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.dot));
      start();
    }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    show(0);
    start();
  };

  document.querySelectorAll('[data-droid-fashion-slideshow]').forEach(initializeDroidFashionSlideshow);
  document.addEventListener('shopify:section:load', (event) => {
    initializeDroidFashionSlideshow(event.target.querySelector('[data-droid-fashion-slideshow]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
